import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UserIcon } from './icons';

interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: number;
}

export function Avatar({ src, name, size = 40 }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const trimmedSrc = src?.trim() || null;

  useEffect(() => {
    setFailed(false);
  }, [trimmedSrc]);

  const showImage = !!trimmedSrc && !failed;
  const initial = name?.trim()?.[0]?.toUpperCase() ?? null;

  return (
    <Circle $size={size} aria-hidden>
      {showImage ? (
        <Photo
          src={trimmedSrc}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : initial ? (
        <FallbackLetter $size={size}>{initial}</FallbackLetter>
      ) : (
        <FallbackIcon $size={size}>
          <UserIcon size={Math.max(14, Math.round(size * 0.48))} />
        </FallbackIcon>
      )}
    </Circle>
  );
}

const Circle = styled.span<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  overflow: hidden;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
`;

const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const FallbackLetter = styled.span<{ $size: number }>`
  font-size: ${({ $size }) => Math.round($size * 0.42)}px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
`;

const FallbackIcon = styled.span<{ $size: number }>`
  display: grid;
  place-items: center;
  color: #fff;
  opacity: 0.95;

  svg {
    display: block;
  }
`;
